import React from 'react';
import { Mail } from 'lucide-react';

const ContactUs: React.FC = () => (
  <div className="max-w-2xl mx-auto py-6 sm:py-10">
    <h1 className="font-display font-normal tracking-tight text-3xl sm:text-4xl text-ink-900">Contact us</h1>
    <p className="mt-4 text-lg leading-relaxed text-ink-600">Have a question, some feedback, or need a hand with Eatsy? We’d love to hear from you.</p>
    <div className="mt-8 rounded-2xl border border-ink-200 bg-surface p-6 sm:p-8">
      <Mail aria-hidden="true" className="h-6 w-6 text-brand-600" />
      <h2 className="mt-4 font-display text-2xl text-ink-900">Email the Eatsy team</h2>
      <a href="mailto:eatsypro@gmail.com" className="mt-3 inline-block break-all text-lg text-brand-700 underline underline-offset-4 hover:text-brand-800">eatsypro@gmail.com</a>
      <p className="mt-4 text-sm leading-relaxed text-ink-600">For account questions, please include the email address you use for Eatsy so we can help.</p>
    </div>
  </div>
);

export default ContactUs;
